import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleIconView, toggleFavouritesView, getFilteredList, setFilteredList, loadFavourites } from '../actions';
import ILListSvg from '../../assets/images/list_view.svg';
import ILIconSvg from '../../assets/images/icon_view.svg';
import FaveIconOnSvg from '../../assets/images/fav_over.svg';
import FaveIconOffSvg from '../../assets/images/fav_up.svg';

class ListController extends Component {

    onClickIconView(){
        this.props.toggleIconView();
    }

    onClickAll(){
        //this.props.selectLevel('all');
        this.props.getFilteredList('all');
        this.props.toggleFavouritesView(false);
    }

    onClickFavourites(){
        if (this.props.isFavouritesView === true){
            this.props.getFilteredList('all');
        } else {
            this.props.setFilteredList(this.props.loadFavourites().payload);
        }
        this.props.toggleFavouritesView(!this.props.isFavouritesView);
    }

    // IL means (icon/list)
    getILIcon(enabled) {
        return enabled ? ILListSvg : ILIconSvg;
    }

    getFaveIcon(enabled) {
        return enabled ? FaveIconOnSvg : FaveIconOffSvg;
    }

    render(){
        return(
            <div>
                <button
                    className="btn-default list"
                    onClick={ () => {
                        this.onClickIconView();
                    }}
                >
                    <img alt="List Icon" src={this.getILIcon(this.props.isIconView)} />
                </button>

                <button
                    className="btn-default fav"
                    onClick={ () => {
                        this.onClickFavourites();
                    }}
                >
                    <img alt="Favourite Star" src={this.getFaveIcon(this.props.isFavouritesView)} />
                </button>

                <button
                    className="btn-default all"
                    onClick={ () => {
                        this.onClickAll();
                    }}
                >
                    View all
                </button>
            </div>
        );
    }
}


function mapStateToProps(state){
    return {
        level: state.mathsDictionary.level,
        filteredList: state.mathsDictionary.filteredList,
        isIconView: state.mathsDictionary.isIconView,
        isFavouritesView: state.mathsDictionary.isFavouritesView,
        favouritesList: state.favourites.favouritesList,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleIconView,
        toggleFavouritesView,
        getFilteredList,
        loadFavourites,
        setFilteredList
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ListController);

